// extracted by mini-css-extract-plugin
module.exports = {"root":"ChangeEntity_root__6IIGj","icon":"ChangeEntity_icon__3XAYs"};